import { useState, useRef, useEffect } from 'react';
import { useSyncState } from 'shared/hooks/useSyncState';
import { TableContent } from 'entities/table/ui/TableContent';
import { useGetMechanicQuery } from 'widgets/mechanic/api/getMechanicApi';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { DrawerMechanic } from 'widgets/mechanic/ui/DrawerMechanic';

const fields = [
  {
    field: 'id',
    title: 'ID',
    width: '10%',
  },
  {
    field: 'name',
    title: 'Наименование',
    width: '30%',
  },
  {
    field: 'description',
    title: 'Описание',
    width: '30%',
  },
  {
    field: 'status',
    title: 'Статус',
    width: '30%',
  },
];

type FilterType = {
  name: number[];
  status: boolean[];
};

export const MechanicWidget = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { app_type } = useParams();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 1,
    count: 10,
    search: '',
  });
  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');
  const searchRef = useRef('');

  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };

  const [filter, setFilter] = useState<FilterType>({
    name: [],
    status: [],
  });

  const { data: mechanicsList, isSuccess } = useGetMechanicQuery({
    app_type: 'admin',
    search: pagination.search,
    page: pagination.page,
    size: pagination.count,
    calculation_function: filter.name,
    is_active: filter.status,
  });

  function handleSearch() {
    setPagination((prev) => ({
      ...prev,
      search: searchRef.current,
    }));
  }

  const handleClearFilter = () => {
    setFilter({
      name: [],
      status: [],
    });
  };
  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };

  // TODO переписать универсально
  const handleApplyFilter = (field: keyof FilterType, value: string | number) => {
    setFilter((prev: any) => {
      if (prev[field].includes(value)) {
        return {
          ...prev,
          [field]: prev[field].filter((item: any) => item !== value),
        };
      }

      return {
        ...prev,
        [field]: [value],
      };
    });
  };

  const handlePromoSelect = (id: number) => {
    navigate(`/promo/mechanic/${id}`);
  };

  useEffect(() => {
    if (app_type) {
      dispatch(setHeaderTitle(app_type!.toUpperCase()));
    }
  }, [app_type]);

  const mlist = { item: [] as any };

  if (mechanicsList && mechanicsList.items) {
    mechanicsList?.items.forEach((item) => {
      mlist.item.push({
        id: item.id,
        description: item.description,
        is_active: item.is_active,
        name: item.name,
        status: item.is_active ? 'Активная' : 'Неактивная',
      });
    });
  }

  return (
    <>
      {isSuccess ? (
        <TableContent<FilterType>
          searchPlaceholder="Поиск по наименованию"
          title="Список механик"
          onSearch={() => handleSearch()}
          applyFilter={handleApplyFilter}
          fields={fields}
          list={{ list: mlist.item }}
          count={mechanicsList.total ?? 0}
          page={pagination.page - 1}
          perPage={pagination.count}
          onPageChange={(_, page) => {
            setPagination((prev) => ({
              ...prev,
              page: page + 1,
            }));
          }}
          onRowsPerPageChange={(e) => {
            setPagination(() => ({
              page: 1,
              count: parseInt(e.target.value),
              search: pagination.search,
            }));
          }}
          isShowSearch={isShowSearch}
          onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
          onClearSearch={handleClearSearch}
          onClearFilter={handleClearFilter}
          search={searchQuery.get()}
          setSearch={handleSetSearch}
          filterFields={[
            {
              title: 'Функция расчета',
              field: 'name',
              list: [
                { title: 'CF0 - Разовое начисление бонусов при достижении уровня продаж', value: '0' },
                { title: 'СF1 - План продаж по брендам', value: '1' },
                {
                  title: 'CF2 - План продаж по брендам, за выполнение плана  начисляется бонус',
                  value: '2',
                },
                { title: 'CF3 - Приветственный бонус, участнику будет начислен бонус.', value: '3' },
                {
                  title: 'CF4 - Приз - сертификат на участие в розыгрыше, промокод, товар',
                  value: '4',
                },
                {
                  title: 'CF5 - Прохождение аудита',
                  value: '5',
                },
                {
                  title: 'CF6 - Заказ (новая механика)',
                  value: '6',
                },
              ],
            },
            {
              title: 'Статус',
              field: 'status',
              list: [
                { title: 'Активная', value: true },
                { title: 'Неактивная', value: false },
              ],
            },
          ]}
          filter={filter}
          onRowClick={handlePromoSelect}
        />
      ) : (
        false
      )}
      <DrawerMechanic />
    </>
  );
};
